import { ATTACHMENTS } from '../constants';
import { AttachmentElement } from '../types';

/** Create a wrex attachments element object. */
export const createAttachments = (children: AttachmentElement['children'] = [{ text: '' }]): AttachmentElement => {
    return { type: ATTACHMENTS, children };
};
